import { RewardType } from '../types/rewardRecords';
export function resolveActivityViewModel(rawInfoRes) {
    try {
        const moduleInfo = rawInfoRes?.moduleInfoList?.[0];
        const cardModule = moduleInfo?.cardModuleInfoVO;
        const rankModule = moduleInfo?.rankModuleInfo;
        const selectedGroups = cardModule?.selectedCardGroups || [];
        const cardGroups = cardModule?.cardGroupInfos || [];
        // 当前城市
        const currentGroup = selectedGroups.length > 0 ? cardGroups?.find(g => g?.groupKey === selectedGroups?.[0]) : undefined;
        // 地标列表
        const landmarks = resolveLandmarks(currentGroup);
        // 分数
        const currentScore = rankModule?.curTeamInfo?.teamScore ?? 0;
        const totalScore = rankModule?.upperLimit ?? 0;
        const startTime = rankModule?.startTime ?? 0;
        const endTime = rankModule?.endTime ?? 0;
        // 免单卡
        return {
            currentCityId: currentGroup?.groupKey,
            currentCityName: currentGroup?.groupName || '',
            totalScore,
            currentScore,
            landmarks,
            startTime,
            endTime
        };
    }
    catch (error) {
        return {};
    }
}
function resolveLandmarks(group) {
    if (!group)
        return [];
    const stepRewards = group?.cards?.map((card, index) => {
        // 从卡片组信息中提取每个地标对应需要的分数
        // score threshold comes from stepRewardInfos ordering
        let cardExtra = {};
        try {
            cardExtra = JSON.parse(card.cardExtra || '{}');
        }
        catch (error) { }
        return {
            cardId: card.cardId,
            name: card.cardName,
            description: card.cardDesc,
            cover: card.cardImage,
            icon: card.cardImage,
            obtained: card.obtained,
            sortOrder: card.sortOrder,
            cardExtra
        };
    });
    return stepRewards.sort((a, b) => {
        // obtained 为 true 的排在前面
        if (a.obtained !== b.obtained)
            return a.obtained ? -1 : 1;
        // 相同 obtained 状态下按 sortOrder 排序
        return (a.sortOrder ?? 0) - (b.sortOrder ?? 0);
    });
}
export function resolveFreeCard(rawRewardRes) {
    if (!rawRewardRes)
        return undefined;
    const reward = rawRewardRes?.rewardItems?.find(item => item.rewardType === RewardType.FREE_CARD);
    if (!reward)
        return undefined;
    return reward;
}
